import React, { useState, useEffect } from 'react';
import { sendContactForm } from './services/emailService';

const ContactForm = ({ isOpen, onClose, mode = 'contact' }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    const result = await sendContactForm(formData);

    if (result.success) {
      setSubmitStatus('success');
      setFormData({ name: '', email: '', company: '', message: '' });
      setTimeout(() => {
        onClose();
        setSubmitStatus(null);
      }, 2000);
    } else {
      setSubmitStatus('error');
    }

    setIsSubmitting(false);
  };

  // Handle escape key and body scroll lock
  useEffect(() => {
    if (!isOpen) return;
    
    const handleEscape = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleEscape);
    document.body.style.overflow = 'hidden';
    
    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const isDemo = mode === 'demo';

  return (
    <div
      onClick={e => e.target === e.currentTarget && onClose()}
      role="dialog" aria-modal="true" aria-labelledby="contact-modal-title"
      style={{ position:"fixed", inset:0, background:"rgba(4,14,18,0.88)", backdropFilter:"blur(10px)", zIndex:999, display:"flex", alignItems:"center", justifyContent:"center", padding:20 }}>
      <div style={{ background:"#ffffff", border:"1px solid #e0e0e0", borderRadius:18, width:"100%", maxWidth:460, overflow:"hidden", boxShadow:"0 20px 60px rgba(0,0,0,0.3)" }}>

        {/* Modal header */}
        <div style={{ background:"#ffffff", padding:"28px 32px 24px", position:"relative", borderBottom:"1px solid #e8e8e8" }}>
          <button onClick={onClose} aria-label="Close modal" style={{ position:"absolute", top:14, right:16, background:"none", border:"none", color:"#999", cursor:"pointer", fontSize:22, lineHeight:1 }}>×</button>
          <p style={{ color:"#00C9A7", fontSize:11, fontFamily:"'Space Mono',monospace", letterSpacing:"0.1em", marginBottom:10, fontWeight:600 }}>
            {isDemo ? 'REQUEST A DEMO' : 'CONTACT US'}
          </p>
          <h2 id="contact-modal-title" style={{ color:"#0C3540", fontSize:21, fontFamily:"'DM Serif Display',serif", lineHeight:1.3, margin:0 }}>
            {isDemo ? 'See Factory Passport in action' : 'Get in touch with us'}
          </h2>
          {isDemo && (
            <p style={{ color:"#555", fontSize:13, marginTop:8, fontFamily:"'DM Sans',sans-serif" }}>
              Schedule a personalized demo with our team
            </p>
          )}
        </div>

        <div style={{ padding:"24px 32px 30px" }}>
          {submitStatus !== 'success' ? (
            <form onSubmit={handleSubmit}>
              <div style={{ marginBottom:14 }}>
                <label style={{ display:"block", color:"#0C3540", fontSize:11, fontFamily:"'Space Mono',monospace", letterSpacing:"0.07em", marginBottom:5, fontWeight:600 }}>
                  FULL NAME
                </label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  placeholder="Your full name"
                  style={{ width:"100%", background:"#f8f9fa", border:"1px solid #d0d0d0", borderRadius:8, padding:"9px 13px", color:"#1a1a1a", fontSize:14, fontFamily:"'DM Sans',sans-serif", outline:"none", boxSizing:"border-box" }}
                />
              </div>

              <div style={{ marginBottom:14 }}>
                <label style={{ display:"block", color:"#0C3540", fontSize:11, fontFamily:"'Space Mono',monospace", letterSpacing:"0.07em", marginBottom:5, fontWeight:600 }}>
                  WORK EMAIL
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  placeholder="you@company.com"
                  style={{ width:"100%", background:"#f8f9fa", border:"1px solid #d0d0d0", borderRadius:8, padding:"9px 13px", color:"#1a1a1a", fontSize:14, fontFamily:"'DM Sans',sans-serif", outline:"none", boxSizing:"border-box" }}
                />
              </div>

              <div style={{ marginBottom:14 }}>
                <label style={{ display:"block", color:"#0C3540", fontSize:11, fontFamily:"'Space Mono',monospace", letterSpacing:"0.07em", marginBottom:5, fontWeight:600 }}>
                  COMPANY
                </label>
                <input
                  type="text"
                  name="company"
                  value={formData.company}
                  onChange={handleChange}
                  placeholder="Company name"
                  style={{ width:"100%", background:"#f8f9fa", border:"1px solid #d0d0d0", borderRadius:8, padding:"9px 13px", color:"#1a1a1a", fontSize:14, fontFamily:"'DM Sans',sans-serif", outline:"none", boxSizing:"border-box" }}
                />
              </div>

              <div style={{ marginBottom:14 }}>
                <label style={{ display:"block", color:"#0C3540", fontSize:11, fontFamily:"'Space Mono',monospace", letterSpacing:"0.07em", marginBottom:5, fontWeight:600 }}>
                  MESSAGE
                </label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows={4}
                  placeholder={isDemo ? 'Please share your preferred date and time for the demo, along with any specific areas you would like us to cover.' : 'How can we help you?'}
                  style={{ width:"100%", background:"#f8f9fa", border:"1px solid #d0d0d0", borderRadius:8, padding:"9px 13px", color:"#1a1a1a", fontSize:14, fontFamily:"'DM Sans',sans-serif", outline:"none", boxSizing:"border-box", resize:"vertical", minHeight:80 }}
                />
              </div>

              {submitStatus === 'error' && (
                <div style={{ color:"#ff6b6b", fontSize:12, textAlign:"center", marginBottom:10, fontFamily:"'DM Sans',sans-serif" }}>
                  Failed to send message. Please try again.
                </div>
              )}

              <button type="submit" disabled={isSubmitting}
                style={{ marginTop:8, width:"100%", background:"linear-gradient(135deg,#00C9A7,#0A8A7A)", border:"none", borderRadius:9, padding:"13px", color:"#fff", fontSize:14, fontWeight:700, fontFamily:"'DM Sans',sans-serif", cursor:"pointer", letterSpacing:"0.03em" }}>
                {isSubmitting ? "Sending…" : (isDemo ? "Schedule Demo →" : "Send Message →")}
              </button>
            </form>
          ) : (
            <div style={{ textAlign:"center", padding:"16px 0" }}>
              <div style={{ width:56, height:56, borderRadius:"50%", border:"2px solid #00C9A7", background:"rgba(0,201,167,0.1)", display:"flex", alignItems:"center", justifyContent:"center", margin:"0 auto 18px" }}>
                <span style={{ color:"#00C9A7", fontSize:26 }}>✓</span>
              </div>
              <h3 style={{ color:"#0C3540", fontSize:19, fontFamily:"'DM Serif Display',serif", marginBottom:10 }}>Message sent!</h3>
              <p style={{ color:"#555", fontSize:14, lineHeight:1.7, fontFamily:"'DM Sans',sans-serif" }}>
                We've received your message at <strong style={{color:"#00C9A7"}}>{formData.email}</strong>.<br/>
                Our team will get back to you within 24 hours.
              </p>
              <button onClick={onClose} style={{ marginTop:22, background:"none", border:"1px solid #00C9A7", borderRadius:8, padding:"9px 24px", color:"#00C9A7", fontSize:13, cursor:"pointer", fontFamily:"'DM Sans',sans-serif", fontWeight:600 }}>Close</button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ContactForm;